import styled from 'styled-components';

export const Container = styled.div`
    background-color: white;
    border-bottom: 1px solid ${ ({ theme: { borderColor } }) => borderColor };
    color: ${ ({ theme: { textColor } }) => textColor };
    display: flex;
    ${ ({ height }) => height ? `height: ${ height };` : '' }
    min-width: 1000px;
    padding: 10px 0px 10px 20px
`;

export const Link = styled.span`
    color: ${ ({ theme: { successColor } }) => successColor };
    cursor: pointer;
    margin-left: 5px;
    text-decoration: underline;
`;

export const Icon = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
`;

export const IconsContainer = styled.div`
    align-items: center;
    display: inline-flex;
    flex-direction: row;
    height: 100%;
    justify-content: space-evenly;
    padding-left: 50px;
    width: 20%;
`;

export const TextContainer = styled.div`
    align-items: flex-start;
    display: inline-flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-evenly;
    width: 80%;
`;

export const Subtitle = styled.div`
    display: block;
    font-size: 15px;
    max-width: 100%;
    overflow: hidden;
    padding-left: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Text = styled.div`
    align-items: center;
    display: flex;
    font-size: 13px;
    font-style: italic;
    padding-left: 20px;
`;

export const Title = styled.div`
    ${ ({ color }) => color ? `color: ${ color };` : '' }
    display: block;
    font-size: 16px;
    font-weight: 500;
`;
